export class AddressGeolocation {
  id?: number;
  addressId?: number;
  lat?: number;
  lng?: number;
  dataSource?: string;
  createdAt: string;
}
